<div class="body-container">
    <div class="page-main">
        <div class="page-container">
            <form *ngIf="isFormReady" [formGroup]="form" novalidate class="form-wrapper">
                <div class="form-wrapper">
                    <div class="form-content">

                        <div  [formGroup]="form" class="form-section">
                            <div class="form-section-side">
                                <h1 class="label-title">Webhook</h1>
                            </div>
                            <div class="form-section-container">
                                <div class="form-section-head">
                                    <div class="form-row">
                                        <p class="typo caption fw300 semi-condensed">Webhook messge</p>
                                    </div>
                                </div>
                                <div class="form-section-body">
                                    <div class="form-row">
                                        <mat-form-field class="custom-mat-form-field size size1of1">
                                            <mat-label>Url</mat-label>
                                            <input matInput formControlName="url" class="custom-mat-select" />

                                            <mat-error><error-messages></error-messages></mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div formArrayName="customHeaders">
                                        <div class="form-row" [formGroupName]="headerIndex"
                                            *ngFor="let header of customHeaders().controls; let headerIndex=index">
                                            <mat-form-field class="custom-mat-form-field size size1of1">
                                                <mat-label>Name</mat-label>
                                                <input matInput formControlName="name" class="custom-mat-select" />

                                                <mat-error><error-messages></error-messages></mat-error>
                                            </mat-form-field>
                                            <mat-form-field class="custom-mat-form-field size size1of1">
                                                <mat-label>Value</mat-label>
                                                <input matInput formControlName="value" class="custom-mat-select" />

                                                <mat-error><error-messages></error-messages></mat-error>
                                            </mat-form-field>
                                            <button mat-button (click)="removeHeader(headerIndex)">Remove</button>

                                        </div>
                                    </div>
                                    <button mat-button (click)="addHeader()">Add new header</button>

                                    <div class="form-row">
                                        <mat-form-field class="custom-mat-form-field size size1of1">
                                            <mat-label>Name</mat-label>
                                            <input matInput formControlName="name" class="custom-mat-select" />

                                            <mat-error><error-messages></error-messages></mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-row">
                                        <mat-form-field class="custom-mat-form-field size size1of1">
                                            <mat-label>Description</mat-label>
                                            <input matInput formControlName="description" class="custom-mat-select" />

                                            <mat-error><error-messages></error-messages></mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-row">
                                        <mat-form-field class="custom-mat-form-field size size1of1">
                                            <mat-label>Secret token</mat-label>
                                            <input matInput formControlName="secretToken" class="custom-mat-select" />
                                            <mat-error><error-messages></error-messages></mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-row">
                                        Trigger
                                    </div>
                                    <div class="form-row" *ngFor="let trigger of triggers">
                                        <mat-checkbox [(ngModel)]="trigger.selected"  [ngModelOptions]="{standalone: true}">{{trigger.name}}</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-section" *ngIf="id">
                            <div class="form-section-side">
                                <h1 class="label-title">Recent events</h1>
                            </div>
                            <div class="form-section-container">
                                <div class="form-section-head">
                                    <div class="form-row">
                                        <p class="typo caption fw300 semi-condensed">Rebillia events trigger webhooks. Use the request details of a webhook to help troubleshoot problems.</p>
                                    </div>
                                </div>
                                <div class="form-section-body">
                                    <div class="form-row">

                                        <app-recent-events [config]="config" [dataSource]="logs"  noResultsMessage="No logs found.">
                                              <ng-template #cellTemplate let-element >
                                                <ng-container *ngIf="element.col.cellTemplate === 'actiontemplate'">
                                                    <button mat-flat-button [routerLink]="'./logs/' + element.data.id"> View</button>
                                                </ng-container>
                                                <ng-container *ngIf="element.col.cellTemplate === 'date'">
                                                {{element.data.createdAt | dateTz:'medium'}}
                                                </ng-container>
                                              </ng-template>
                                        </app-recent-events>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <nav class="post-form">

                    <button mat-flat-button (click)="onSubmit()" [disabled]="formSubmitted" color="primary"
                        class="custom-mat-button-primary rounded typo uppercase size size1of1  ">Save Webhook</button>
                        <button *ngIf="id" mat-stroked-button  [matMenuTriggerFor]="menu"  ngClass="{'is--loading': formSubmitted}" color="primary" class="custom-mat-button-primary rounded typo uppercase size size1of1 margin m__160000">Test</button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngFor="let trigger of companyWebhookTriggers" (click)="testCompanyWebhookTriggers(trigger.id)">
                                <mat-icon>double_arrow</mat-icon>
                              <span>{{trigger.rblWebhookTrigger.name}}</span>
                            </button>
                          </mat-menu>
                </nav>
            </form>
            <!-- skeleton form-sections -->
            <div *ngIf="!isFormReady">
                <skeleton-loader-form [top]=true [numberOfInputs]=4></skeleton-loader-form>
                <skeleton-loader-form [numberOfInputs]=2></skeleton-loader-form>
            </div>
        </div>
    </div>
</div>
